import React from "react";

interface TabButtonProps {
  label: string;
  subLabel?: string;
  tabKey: string;
  activeTab: string | null;
  onClick: () => void;
  disabled?: boolean;
  count?: number;
}

const styles = {
  button: {
    flex: 1,
    padding: "8px 16px",
    border: "none",
    background: "none",
    marginBottom: "-1px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
  },
  subLabel: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#999",
    lineHeight: 1.3,
  },
  activeBorder: "2px solid #1976d2",
  inactiveBorder: "2px solid transparent",
} as const;

export default function TabButton({
  label,
  subLabel,
  tabKey,
  activeTab,
  onClick,
  disabled,
  count,
}: TabButtonProps) {
  const isActive = activeTab === tabKey;
  return (
    <button
      onClick={() => !disabled && onClick()}
      style={{
        ...styles.button,
        cursor: disabled ? "default" : "pointer",
        fontWeight: isActive ? 600 : 400,
        color: disabled ? "#ccc" : isActive ? "#1976d2" : "#666",
        borderBottom: isActive ? styles.activeBorder : styles.inactiveBorder,
      }}
    >
      <span>
        {label}
        {count !== undefined ? ` (${count})` : ""}
      </span>
      {subLabel ? <span style={styles.subLabel}>{subLabel}</span> : null}
    </button>
  );
}
